import styled from 'styled-components';

export interface AutocompleteProps {
	suggestions?: string[];
	pick?: (value: string) => void;
	placeholder?: string;
	value?: string;
}

export const Container = styled.div`
	position: relative;
`;

export const Input = styled.input`
	background: transparent;
	border: ${({ theme }) => `1px solid ${theme.colors.principal.ceres}`};
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	height: 48px;
	padding: 8px 14px;
	width: 100%;

	&:focus {
		border: ${({ theme }) => `1px solid ${theme.colors.principal.vanth}`};
	}
`;

export const SuggestionsList = styled.ul`
	background-color: #fff;
	border: ${({ theme }) => `1px solid ${theme.colors.principal.ceres}`};
	border-radius: 8px;
	list-style-type: none;
	margin: 0;
	margin-top: 8px;
	max-height: 150px;
	overflow-y: auto;
	padding: 0;
	position: absolute;
	width: 100%;
	z-index: 1;
`;

export const SectionTitle = styled.li`
	background-color: ${({ theme }) => theme.colors.principal.air};
	color: ${({ theme }) => theme.colors.principal.abell};
	font-weight: bold;
	padding: 10px;
`;

export const SuggestionItem = styled.li<{ isActive: boolean }>`
	background-color: ${({ isActive, theme }) =>
		isActive ? `${theme.colors.principal.eris}` : '#fff'};
	color: ${({ theme }) => theme.colors.principal.vanth};
	cursor: pointer;
	padding: 10px;

	&:hover {
		background-color: ${({ theme }) => theme.colors.principal.eris};
		color: ${({ theme }) => theme.colors.principal.orion};
	}
`;
